// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.scss\"","emeraldColor":"#02A07D","updateUrlButton":"UpdateUrl_updateUrlButton__beQYT"};